import React from "react";
import clsx from "clsx";

export function Box({
  children,
  className,
  ...props
}: React.PropsWithChildren<{ className?: string }>) {
  return (
    <div className={clsx("p-6 bg-white", className)} {...props}>
      {children}
    </div>
  );
}
